import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import Backdrop from '../../../backdrop';
import useAuth from '../../../../hooks/useAuth';
import ProgramCard from '../../post-enrollment/EnrollInPrograms/ProgramCard';
import ProgramDetailsModal from '../../post-enrollment/EnrollInPrograms/ProgramDetailsModal';
import GreenFutureChoiceIcon from '../../../../static/green-future-choice.svg';
import ProgramDetails from './ProgramDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subTitleHolder: {
      fontWeight: 'bold',
      margin: theme.spacing(0, 0, 0, 0),
    },
  }),
);

export type GreenFutureChoiceProps = {
  isEnrolled: boolean;
  isRenewablesEligible: boolean;
  isLoading: boolean;
  onEnrollmentChange: (checked: boolean) => void;
};
const GreenFutureChoice = ({
  isEnrolled,
  isRenewablesEligible,
  isLoading,
  onEnrollmentChange,
}: GreenFutureChoiceProps) => {
  const { t } = useTranslation();
  const [viewDetails, setViewDetails] = useState<boolean>(false);

  const classes = useStyles();
  const { isAuthenticated } = useAuth();

  if (isLoading && isAuthenticated) {
    return <Backdrop forceOpen />;
  }

  if (!isRenewablesEligible) {
    return null;
  }

  const ProgramDetailsProps = {
    isEnrolled,
    isEligible: true,
    loading: false,
  };

  return (
    <Grid style={{ margin: '32px 0' }}>
      <Grid container direction={'column'} spacing={2}>
        <Grid item>
          <Typography className={classes.subTitleHolder} variant="h4">
            {t('GO_GREEN')}
          </Typography>
        </Grid>

        <ProgramCard
          isEnrolled={isEnrolled}
          title={t('GREEN_FUTURE_CHOICE_TITLE_CASE')}
          description={t('GREEN_FUTURE_CHOICE__SUBHEADER')}
          icon={<GreenFutureChoiceIcon style={{ width: '60px' }} />}
          enrolledText="Selected"
          viewProgramDetails={() => setViewDetails(true)}
          isDeleteEnabled={false}
          onCancel={() => undefined}
        />

        {viewDetails && (
          <ProgramDetailsModal
            onClose={() => setViewDetails(false)}
            open={viewDetails}
          >
            <ProgramDetails
              onClose={() => setViewDetails(false)}
              onSubmit={() => {
                onEnrollmentChange(!isEnrolled);
                setViewDetails(false);
              }}
              {...ProgramDetailsProps}
            />
          </ProgramDetailsModal>
        )}
      </Grid>
    </Grid>
  );
};

export default GreenFutureChoice;
